import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { TanStackDevtools } from '@tanstack/react-devtools';

import TanStackQueryDevtools from '../integrations/tanstack-query/devtools';
import { Toaster } from '@/components/ui/sonner.tsx';
import { DocumentTitle } from '@/components/document-title.tsx';

import type { QueryClient } from '@tanstack/react-query';

// Context is intended for things like:
// - Dependency Injection
// - Breadcrumbs
// - Dynamic meta-tag management
// NOT FOR STATE, because it's challenging to access outside loaders and route components
interface MyRouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <>
      <DocumentTitle />
      <Outlet />
      <Toaster />
      <TanStackDevtools
        config={{
          position: 'bottom-right',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          TanStackQueryDevtools,
        ]}
      />
    </>
  ),
});
